<template>
  <Modal :open="isOpen" :close="handleClose">
    <div class="grid grid-cols-6 text-left" style="width: 1200px">
      <div class="col-span-6 m-5">
        <div class="flex justify-end">
          <button
            type="button"
            @click="saveToFB"
            @click.stop.prevent
            :class="`${
              loading === 1 && 'animate-pulse'
            } inline-flex items-center px-4 py-2 border border-green-300 rounded-md shadow-sm text-xs font-medium text-green-700 bg-white hover:bg-green-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 `"
          >
            Save
            <IconSync
              class="ml-1 animate-spin text-green"
              v-if="loading === 1"
            />
            <IconSolidCheck v-if="loading === 2" />
          </button>
        </div>
        <div>
          <div class="grid grid-cols-6 gap-3">
            <h2 class="col-span-6 font-black text-gray-500">Create An Image</h2>
            <hr class="col col-span-6" />
            <div class="col col-span-6" v-if="errors.length">
              <b>Please correct the following error(s):</b>
              <ul>
                <li
                  v-for="(error, index) in errors"
                  :key="index"
                  style="color: red"
                >
                  {{ error }}
                </li>
              </ul>
            </div>
            <div class="col col-span-2">
              <div class="mb-3">
                <TextField
                  label="Title"
                  placeholder="Enter image title"
                  v-model="image.title"
                />
              </div>
              <div class="mb-3">
                <label for="trend" class="block text-sm font-bold text-gray-600"
                  >Trend Tag</label
                >
                <MultiSelect
                  :options="fbStlTags.trend"
                  :label="'label'"
                  :handleUpdate="handleUpdate3"
                  :selected="image.tags.trend"
                />
              </div>
              <div class="mb-3">
                <label
                  for="finish"
                  class="block text-sm font-bold text-gray-600"
                  >Finish Tag</label
                >
                <MultiSelect
                  :options="fbStlTags.finish"
                  :label="'label'"
                  :handleUpdate="handleUpdate4"
                  :selected="image.tags.finish"
                />
              </div>
              <div>
                <label
                  for="project"
                  class="block text-sm font-bold text-gray-600"
                  >Project Tag</label
                >
                <MultiSelect
                  :options="fbStlTags.project"
                  :label="'label'"
                  :handleUpdate="handleUpdate5"
                  :selected="image.tags.project"
                />
              </div>
            </div>
            <div class="col col-span-4">
              <div class="mb-3">
                <label
                  for="product_skus"
                  class="block text-sm font-bold text-gray-600"
                  >Product Skus</label
                >
                <SearchAndMultiSelect
                  :options="productSkusList"
                  :label="'label'"
                  :handleUpdate="handleUpdate"
                  :selected="image.product_skus"
                  :handleInput="handleInput"
                />
              </div>
              <div class="mb-3">
                <label
                  for="related_skus"
                  class="block text-sm font-bold text-gray-600"
                  >Related Skus</label
                >
                <SearchAndMultiSelect
                  :options="productSkusList"
                  :label="'label'"
                  :handleUpdate="handleUpdate2"
                  :selected="image.related_skus"
                  :handleInput="handleInput"
                />
              </div>
              <div>
                <TextField
                  label="Image"
                  placeholder="Enter image URL or upload less than 2MB image file"
                  v-model="image.image_url"
                />
                <input
                  accept="image/*"
                  class="cursor-pointer border-4 border-main-300 p-2 rounded-lg mt-5 flex justify-start"
                  type="file"
                  @change="handleImage"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapGetters } from "vuex";
import * as Constants from "@/store/constants";
import * as Actions from "@/store/actions.type";
import Modal from "@/components/Shared/Modal/Base";
import IconSolidCheck from "@/assets/icons/IconSolidCheck";
import IconSync from "@/assets/icons/IconSync";
import TextField from "@/components/Shared/Input/TextField";
import MultiSelect from "@/components/Shared/Input/MultiSelect";
import SearchAndMultiSelect from "@/components/Shared/Input/SearchAndMultiSelect";
import { s3 } from "@/common/aws";

export default {
  name: "ImageCreateModal",
  components: {
    Modal,
    IconSolidCheck,
    IconSync,
    TextField,
    MultiSelect,
    SearchAndMultiSelect
  },
  props: {
    handleClose: {
      type: Function,
      required: true
    },
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      image: Object.assign({}, Constants.IMAGE_DEFAULT),
      loading: 0,
      errors: []
    };
  },
  computed: {
    ...mapGetters(["currentUser", "fbStlTags", "searchMultiProducts"]),
    productSkusList() {
      let list = [];
      this.searchMultiProducts
        .filter((i) => i.country === "au" && i.status === "publish")
        .forEach((product) => {
          list.push({
            id: product.sku,
            label: product.name + " | " + product.sku
          });
        });
      return list;
    }
  },
  watch: {
    isOpen() {
      if (!this.isOpen) {
        this.image = Object.assign({}, Constants.IMAGE_DEFAULT, {
          tags: Object.assign({}, Constants.IMAGE_DEFAULT.tags, {
            trend: [],
            finish: [],
            project: []
          })
        });
        this.loading = 0;
        this.errors = [];
      }
    }
  },
  methods: {
    async handleImage(e) {
      if (e.target.files[0].size < 2097152) {
        let params = {
          Bucket: "shopthelook-uploads",
          Key: `${e.target.files[0].name.replace(/\s+/g, "-").toLowerCase()}`,
          Body: e.target.files[0],
          ContentType: "image/jpg",
          ContentDisposition: "inline"
        };

        this.errors = [];

        try {
          await s3.upload(params, (err, result) => {
            if (err) {
              this.errors.push("S3 Uploading ERROR: " + err.message);
            } else {
              this.image.image_url = result.Location;
            }
          });
        } catch (error) {
          this.errors.push("S3 Uploading ERROR: " + error.message);
        }
      } else {
        this.errors.push("The size of image file should less than 2MB.");
      }
    },
    saveToFB(e) {
      if (this.image.title && this.image.image_url) {
        this.loading = 1;
        const data = {
          title: this.image.title,
          image_url: this.image.image_url,
          product_skus: this.image.product_skus,
          related_skus: this.image.related_skus,
          tags: {
            trend: this.image.tags.trend,
            finish: this.image.tags.finish,
            project: this.image.tags.project
          },
          date_added: new Date().toJSON(),
          modified_by: `${this.currentUser.email.split("@")[0].toUpperCase()}`
        };
        this.$store
          .dispatch(Actions.FB_SAVE_CREATED_IMAGE, {
            region: "au",
            data: data
          })
          .then(() => this.handleClose());
      }

      this.errors = [];

      if (!this.image.title) {
        this.errors.push("Image title required.");
      }
      if (!this.image.image_url) {
        this.errors.push("Image URL required.");
      }

      e.preventDefault();
    },
    handleInput(value) {
      this.$store.dispatch(Actions.AWS_SEARCH_MULTISELECT_PRODUCTS, {
        search: value,
        region: this.getRegion
      });
    },
    handleUpdate(value) {
      this.image.product_skus =
        this.image.product_skus.filter((t) => t.id === value.id).length > 0
          ? this.image.product_skus.filter((t) => t.id !== value.id)
          : [...this.image.product_skus, value];
    },
    handleUpdate2(value) {
      this.image.related_skus =
        this.image.related_skus.filter((t) => t.id === value.id).length > 0
          ? this.image.related_skus.filter((t) => t.id !== value.id)
          : [...this.image.related_skus, value];
    },
    handleUpdate3(value) {
      this.image.tags.trend =
        this.image.tags.trend.filter((t) => t.id === value.id).length > 0
          ? this.image.tags.trend.filter((t) => t.id !== value.id)
          : [...this.image.tags.trend, value];
    },
    handleUpdate4(value) {
      this.image.tags.finish =
        this.image.tags.finish.filter((t) => t.id === value.id).length > 0
          ? this.image.tags.finish.filter((t) => t.id !== value.id)
          : [...this.image.tags.finish, value];
    },
    handleUpdate5(value) {
      this.image.tags.project =
        this.image.tags.project.filter((t) => t.id === value.id).length > 0
          ? this.image.tags.project.filter((t) => t.id !== value.id)
          : [...this.image.tags.project, value];
    }
  }
};
</script>
